var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app_wrap"},[_c('Carousel',{attrs:{"carousel-data":_vm.carouselData}}),_c('CoreTechMod',{attrs:{"core-tech-data":_vm.coreTechData}}),_c('Solution'),_c('NewsCenter',{attrs:{"news-data":_vm.newsData}}),_c('AboutUs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }